<h2 mat-dialog-title>Detail Info</h2>
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div class="col-2">
      <img [src]="data.country.flags.svg" height="50" width="100" />
    </div>
    <div class="col-10">
      <div class="row">
        <div class="col-2 font-weight-bold">Name</div>
        <div class="col-2 font-weight-bold">Population</div>
        <div class="col-2 font-weight-bold">Capital</div>
        <div class="col-2 font-weight-bold">Region</div>
        <div class="col-4 font-weight-bold">Subregion</div>
      </div>
      <div class="row">
        <div class="col-2">{{ data.country.name.common }}</div>
        <div class="col-2">{{ data.country.population | number }}</div>
        <div class="col-2">{{ data.country.capital[0] }}</div>
        <div class="col-2">{{ data.country.region }}</div>
        <div class="col-4">{{ data.country.subregion }}</div>
      </div>
    </div>
  </div>
  <div>
    <ngx-charts-bar-vertical
      [view]="view"
      [scheme]="colorScheme"
      [results]="single"
      [gradient]="gradient"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
    >
    </ngx-charts-bar-vertical>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
